import { Allowed_List_Phone_Number_Time_Period } from '@occc/graphql';
import { UseSearchParamsParameters } from '@occc-app/hooks/useSearchParams';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { UseAdvancedQueryParamParams } from '@occc/utils-query-params';
import { formatDateTime } from '@occc-app/lib/date';

import { isAValidDate } from './table-filter/table-filter.validation';
import { parseStringToDate } from './allow-list.utils';

export const DEFAULT_ALLOW_LIST_PHONE_NUMBERS_TIME_PERIOD =
  Allowed_List_Phone_Number_Time_Period.Last_24Hours;

export const allowListSearchParams: UseSearchParamsParameters = {
  searchParamName: 'allow-list-search',
  beforeParamName: 'allow-list-before',
  afterParamName: 'allow-list-after',
};

export const startDateParamName = 'allow-list-start-date';
export const endDateParamName = 'allow-list-end-date';
export const defaultDateQueryParams: Pick<
  UseAdvancedQueryParamParams<Date | undefined>,
  'beforeParamName' | 'afterParamName' | 'defaultValue' | 'readValidator' | 'parse' | 'format'
> = {
  beforeParamName: allowListSearchParams.beforeParamName,
  afterParamName: allowListSearchParams.afterParamName,
  defaultValue: undefined,
  readValidator: isAValidDate,
  parse: parseStringToDate,
  format: formatDateTime,
};
export const defaultStartDateQueryParams: UseAdvancedQueryParamParams<Date | undefined> = {
  paramName: startDateParamName,
  ...defaultDateQueryParams,
};
export const defaultEndDateQueryParams: UseAdvancedQueryParamParams<Date | undefined> = {
  paramName: endDateParamName,
  ...defaultDateQueryParams,
};

const enteredOnParamName = 'allow-list-entered-on';
export const defaultEnteredOnQueryParams: UseAdvancedQueryParamParams<Allowed_List_Phone_Number_Time_Period> =
  {
    paramName: enteredOnParamName,
    allowedValues: Object.values(Allowed_List_Phone_Number_Time_Period),
    defaultValue: DEFAULT_ALLOW_LIST_PHONE_NUMBERS_TIME_PERIOD,
    beforeParamName: allowListSearchParams.beforeParamName,
    afterParamName: allowListSearchParams.afterParamName,
  };

export const defaultPaginationParams = {
  beforeParamName: allowListSearchParams.beforeParamName,
  afterParamName: allowListSearchParams.afterParamName,
};
